import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/folder.vue
var o = {
	name: "DtIconFolder",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--folder"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Folder",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M.94 1.44A1.5 1.5 0 0 1 2 1h1.968a1.5 1.5 0 0 1 1.242.671l.413.604a.5.5 0 0 0 .414.225H10A1.5 1.5 0 0 1 11.5 4v5a1.5 1.5 0 0 1-1.5 1.5H2C1.174 10.5.5 9.826.5 9V2.5c0-.398.158-.78.44-1.06ZM2 2a.5.5 0 0 0-.5.5V9c0 .274.226.5.5.5h8a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H6.032a1.5 1.5 0 0 1-1.242-.671l-.413-.604A.5.5 0 0 0 3.963 2H2Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=folder.js.map